module.exports = __webpack_public_path__ + "img/niunai4.a3d19649.jpg";